// toast.js
import { message } from 'antd';

export type NotificationType = 'success' | 'info' | 'warning' | 'error';

export enum NotifyType {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

const toast = (type: NotificationType, text: string, duration = 3) => {
  switch (type) {
    case 'success':
      message.success(text, duration);
      break;
    case 'error':
      message.error(text, duration);
      break;
    case 'info':
      message.info(text, duration);
      break;
    case 'warning':
      message.warning(text, duration);
      break;
    default:
      message.open({ content: text, duration });
  }
};

export default toast;
